/**
 * Ryan O'Dowd
 * 2024-02-08
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({safeAreaInsets}) => {
  return {
    innerContainer: {
      flexGrow: 1,
      justifyContent: 'space-between',
      // @TODO: paddingHorizontal: 8,
    },
    assignmentWrapper: {
      flex: 1,
    },
    finishButtonWrapper: {
      margin: 8,
      marginBottom: safeAreaInsets.bottom,
    },
  };
};

export default getStyles;
